import { FC } from 'react';

import { SvgIcon, SvgIconProps } from '@thirdspacelearning/library';

interface Props extends SvgIconProps {}

const BadgeLocked: FC<Props> = ({ ...props }) => (
    <SvgIcon
        width="81"
        height="81"
        viewBox="0 0 81 81"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="badge-locked"
        {...props}
    >
        <rect
            x="3.11538"
            y="3.11538"
            width="74.7692"
            height="74.7692"
            rx="37.3846"
            fill="#EEEEEE"
        />
        <rect
            x="3.11538"
            y="3.11538"
            width="74.7692"
            height="74.7692"
            rx="37.3846"
            stroke="#E0E0E0"
            strokeWidth="6.23077"
            fill="white"
        />
        <rect
            x="32.6123"
            y="38.2432"
            width="16.9569"
            height="13.6668"
            fill="#8F411C"
        />
        <path
            d="M49.455 34.5766V26.1599C49.455 21.5115 45.6867 17.7432 41.0383 17.7432V17.7432C36.3899 17.7432 32.6216 21.5114 32.6216 26.1599V34.5766"
            stroke="#A5ACB6"
            strokeWidth="4.16106"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.2715 31.8362C25.2715 30.2955 26.5204 29.0466 28.0611 29.0466H53.8649C55.4055 29.0466 56.6545 30.2955 56.6545 31.8362V57.6399C56.6545 59.1806 55.4055 60.4295 53.8649 60.4295H28.0611C26.5204 60.4295 25.2715 59.1806 25.2715 57.6399V31.8362ZM42.3654 45.2142C43.5064 44.6846 44.2976 43.5287 44.2976 42.1881C44.2976 40.3465 42.8047 38.8536 40.9631 38.8536C39.1216 38.8536 37.6287 40.3465 37.6287 42.1881C37.6287 43.4917 38.3768 44.6206 39.4671 45.1689L39.1564 49.9848C39.1364 50.2947 39.3823 50.557 39.6928 50.557H42.2904C42.6077 50.557 42.856 50.2836 42.8255 49.9677L42.3654 45.2142Z"
            fill="#FFA726"
        />
    </SvgIcon>
);

export default BadgeLocked;
